export default "__VITE_ASSET__Ck02Gu4n__"